import { FC } from 'react';
import { useIntl } from 'react-intl';
import { PageTitle } from '../../../_metronic/layout/core';
import PartnerStoresList from '../../modules/partner-stores/components/PartnerStoresList';

const PartnerStoresPage: FC = () => {
  const intl = useIntl();

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'menu.partnerStores' })}
      </PageTitle>
      <div className="row gy-4 mw-800px">
        <div className="card p-10">
          <PartnerStoresList />
        </div>
      </div>
    </>
  );
};

export { PartnerStoresPage };
